export const removeUnderscore = (str?: string): string => {
  return (str ?? '').replace(/[_-]/g, ' ');
};
